import React, { useState } from "react"
import tw from "twin.macro"
import styled from "@emotion/styled"
import illustration from "../../images/Landing-Page_Cover.jpg"
import { Controller, useForm } from "react-hook-form"
import { ErrorMessage } from "./ErrorMessage"
import { SuccessAlert } from "./SuccessAlert"
import { CustomController } from "./CustomController"
import { postContactFormData } from "../../helpers/axios"
import WFLogo from "../../images/weFocus_tr.png"
import TILogo from "../../images/talent_tr.png"
import MobileCover from "../../images/Mobile.jpg"

const ContainerBase = tw.div`relative`
const Container = tw(
  ContainerBase
)`min-h-screen bg-primary-900 text-white font-medium flex justify-center`
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 sm:p-12`
const MainContent = tw.div`mt-8 flex flex-col items-center`
const Heading = tw.h1`text-2xl font-extrabold`
const FormContainer = tw.div`w-full flex-1 mt-8`
const Form = tw.form`w-96`

const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-primary-900 text-gray-100 w-full py-4 rounded-lg hover:bg-primary-700 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`
const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 bg-gray-100 text-center hidden lg:flex justify-center`
const IllustrationImage = styled.div`
  ${props => `background-image: url("${props.imageSrc}");`}
  ${tw`lg:w-full bg-size80 bg-center bg-no-repeat`}
`
const MobileIllustrationImage = styled.div`
  ${props => `background-image: url("${props.imageSrc}");`}
  ${tw`block lg:hidden w-full h-24 bg-center bg-no-repeat mb-6`}
`

const CheckBoxContainer = tw.div`flex flex-direction[column] items-start w-full`
const CheckBoxWrapper = tw.div`flex items-start justify-start mb-3`
const CheckBox = tw.input`rounded bg-white border-gray-500 focus:border-gray-500 transition[all]
outline-none box-shadow[none] focus:box-shadow[none] duration-200 checked:bg-primary-500 hover:bg-primary-400
hocus:bg-primary-400 text-gray-700 checked:focus:bg-primary-500 not-checked:bg-white checked:hover:bg-primary-400`
const CheckBoxText = styled.label`
  ${tw`text-sm ml-2 text-gray-700`}
  margin-top: -0.17rem;
`
const CheckBoxLink = tw.a`text-blue-400 font-semibold border-b-2 border-transparent 
hocus:border-blue-600 pb-1 transition[all] duration-300`
const CheckboxImg = tw.img`mb-1 min-h-16`
const Link = tw.a`text-blue-400 text-xs border-b-2 border-transparent 
hover:text-blue-600`
const Label = tw.div`text-base text-gray-700 mt-3 `

function ContactUs() {
  const [result, setResult] = useState({
    loading: false,
    success: false,
    error: false,
  })
  const { handleSubmit, control } = useForm({
    mode: "all",
  })
  const onSubmit = async data => {
    try {
      setResult(state => ({ ...state, loading: true }))
      const {
        fullname,
        email,
        phone,
        companyName,
        weFocus,
        talent,
        advPerm,
        cookiePerm,
      } = data
        const feedbackMessage = `(Wefocus: ${weFocus ? 'Yes' : 'No'}) (Talent: ${talent ? 'Yes' : 'No'})`
        const payload = {
          domain: 'wefocus.io',
          name: fullname,
          email,
          phone: String(phone),
          company: companyName,
          message: feedbackMessage,
          isTermsAccept: true,
          isCommunicationAccept: advPerm === undefined ? false : true,
        }
        postContactFormData(payload).then((resp) => {
          if (resp.status) {
            setResult({ loading: false, success: true, error: false })
          }
        })
      
    } catch (error) {
      setResult({ loading: false, success: false, error: true })
    }
  }
  const illustrationImageSrc = illustration
  const headingText = "Dijital İK Çözümlerini Keşfedin!"

  return (
    <Container>
      <Content>
        <MainContainer>
          <MainContent>
            <MobileIllustrationImage imageSrc={MobileCover} />
            <Heading>{headingText}</Heading>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <FormContainer>
                <CustomController
                  name="fullname"
                  rules={{ required: true, maxLength: 20 }}
                  placeholder="Ad Soyad*"
                  control={control}
                />
                <CustomController
                  name="email"
                  rules={{ required: true, pattern: /^([\w-.]+@(?!gmail\.com)(?!yahoo\.com)(?!hotmail\.com)(?!mail\.ru)(?!yandex\.ru)(?!mail\.com)([\w-]+.)+[\w-]{2,4})?$/ }}
                  placeholder="E-posta*"
                  control={control}
                />
                <CustomController
                  name="phone"
                  rules={{
                    required: true,
                    minLength: 6,
                    maxLength: 12,
                  }}
                  placeholder="Telefon Numarası*"
                  control={control}
                />
                <CustomController
                  name="companyName"
                  rules={{
                    required: true,
                    maxLength: 40,
                  }}
                  placeholder="Şirket Adı*"
                  control={control}
                />
                <Label>Ürünümüz hakkında bilgi almak ister misiniz?</Label>
                <div className="flex mb-5 mt-5">
                  <Controller
                    name="weFocus"
                    control={control}
                    render={({ field }) => {
                      return (
                        <CheckBoxContainer>
                          <CheckBoxWrapper>
                            <CheckBox {...field} id="weFocus" type="checkbox" />
                            <CheckBoxText htmlFor="weFocus">
                              <CheckboxImg src={WFLogo} />
                              <Link
                                href={`https://wefocus.app/tr/?utm_source=netlify&utm_medium=cpc&utm_campaign=e-book`}
                                target="_blank"
                              >
                                WeFocus'u Keşfet
                              </Link>
                            </CheckBoxText>
                          </CheckBoxWrapper>
                        </CheckBoxContainer>
                      )
                    }}
                  />
                  <Controller
                    name="talent"
                    control={control}
                    render={({ field }) => {
                      return (
                        <CheckBoxContainer>
                          <CheckBoxWrapper>
                            <CheckBox id="talent" {...field} type="checkbox" />
                            <CheckBoxText htmlFor="talent">
                              <CheckboxImg src={TILogo} />
                              <Link
                                href={`https://www.talent-interview.com/tr/?utm_source=netlify&utm_medium=cpc&utm_campaign=e-book`}
                                target="_blank"
                              >
                                Talent Interview'ı Keşfet
                              </Link>
                            </CheckBoxText>
                          </CheckBoxWrapper>
                        </CheckBoxContainer>
                      )
                    }}
                  />
                </div>
                <Controller
                    name="advPerm"
                    control={control}
                    render={({ field }) => {
                      return (
                        <CheckBoxContainer>
                          <CheckBoxWrapper>
                            <CheckBox {...field} type="checkbox" />
                            <CheckBoxText>
                              Huawei Telekomünikasyon Dış Tic. Ltd. Şti.’nin etkinlik, tanıtım ve fırsatlarından haberdar olmak istiyorum.
                            </CheckBoxText>
                          </CheckBoxWrapper>
                        </CheckBoxContainer>
                      )
                    }}
                  />
                {/* Terms of Use and Privacy Policy Checkbox */}
                <Controller
                  name="cookiePerm"
                  control={control}
                  rules={{ required: "Lütfen 'Kişisel Verilerin İşlenmesine Dair Aydınlatma Metni’ni okudum' kutucuğunu işaretleyiniz." }}
                  render={({ field, fieldState: { error } }) => {
                    return (
                      <CheckBoxContainer>
                        <CheckBoxWrapper>
                          <CheckBox
                            {...field}
                            id="termsOfUse"
                            type="checkbox"
                          />
                          <CheckBoxText htmlFor="termsOfUse">
                            <CheckBoxLink
                              href={`/privacy-policy/`}
                              target="_blank"
                              >
                              Kişisel Verilerin İşlenmesine Dair Aydınlatma Metni
                            </CheckBoxLink>
                              ’ni okudum{" "}
                            
                          </CheckBoxText>
                        </CheckBoxWrapper>
                        {error && <ErrorMessage error={error} />}
                      </CheckBoxContainer>
                    )
                  }}
                />
                <SubmitButton
                  type="submit"
                  value="Submit"
                  disabled={(result.loading || result.success) && result.error}
                >
                  {result.loading ? "Gönderiliyor" : "Gönder"}
                </SubmitButton>
                <div className="text-center">
                  {result.error && (
                    <ErrorMessage error={{ message: "Error" }} />
                  )}
                </div>
              </FormContainer>
            </Form>
          </MainContent>
        </MainContainer>
        <IllustrationContainer>
          <IllustrationImage imageSrc={illustrationImageSrc} />
        </IllustrationContainer>
      </Content>
      {result.success && <SuccessAlert />}
    </Container>
  )
}

export default ContactUs
